var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-list"},_vm._l((_vm.objects),function(object){return _c('Tab',{key:object.objectId,staticClass:"tab-list__item",attrs:{"text":object.name,"isActive":object.isActive},on:{"click":() => _vm.tabClickHandler(object.objectId)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }